import React from 'react';

import { Tooltip } from '@trqk/components';
import { formatDollarsStatement } from '@trqk/utils';

interface TopFiveHeaderProps {
    source: string;
    earnings: Maybe<number>;
    earningsColor: 'secondary' | 'quarternary';
    episode: Maybe<string>;
    show: string;
}

const textMaxLength = 50;

/**
 * Displays the header for a TopFiveCard, which includes the source, show, and earnings.
 * @param param0
 */
export const TopFiveHeader = (props: TopFiveHeaderProps): JSX.Element => {
    const { source, earnings, earningsColor, episode } = props;

    let { show } = props;

    if (show === 'not_reported' || show === 'not reported') {
        show = '';
    }

    const earningsFormatted =
        earnings === null ? '' : formatDollarsStatement(earnings);
    const tooltipMessage = (
        <div>
            {source.length < 0 && <>{source}&nbsp;/&nbsp;</>}
            <span className="font-bold">{show}</span>
            {episode && <>&nbsp;/&nbsp;{episode}</>}
            :&nbsp;{earningsFormatted}
        </div>
    );
    // If necessary, manually truncate the header when it would possibly extend over two lines: if
    // the length of the source and show together would be over textMaxLength, shorten the show by
    // the difference.
    const textLength = source.length + show.length + (episode?.length ?? 0);
    const showAndEpisode = episode ? `${show}: ${episode}` : show;

    const displayShow =
        textLength > textMaxLength
            ? `${showAndEpisode.slice(0, textMaxLength - source.length)}...`
            : showAndEpisode;
    const headerContent = (
        <div className="mx-2 text-lg text-center">
            {source}
            <span className="ml-2 font-bold text">{displayShow}</span>
            <span className={`ml-2 font-bold text-${earningsColor}-500`}>
                {earningsFormatted}
            </span>
        </div>
    );

    // If the show was not truncated, no need to use a tooltip
    if (displayShow.length <= show.length) {
        return headerContent;
    }

    return (
        <Tooltip message={tooltipMessage} position="bottom" background="light">
            {headerContent}
        </Tooltip>
    );
};
